// extracted by mini-css-extract-plugin
export default {"modal":"modal__2_970","body":"body__3G1Mi","cta":"cta__3lSKw","title":"title__OBeCQ","single":"single__jFcWC","actions":"actions__2R06K","separator":"separator__3HPzO"};